export default __webpack_public_path__ + "static/media/01.f0e99b03.webp";